import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill'; // WYSIWYG editor
import 'react-quill/dist/quill.snow.css'; // React-Quill CSS
import styles from './ChangeEmailBody.module.css';

// Define the available email types and their labels
const EMAIL_TYPES = {
  admin: 'Admin Email Template',
  userHigh: 'User High Star Email Template',
  userLow: 'User Low Star Email Template',
  companyInvitation: 'Company Invitation Email Template',
  passwordReset: 'Forgot Password Email Template'
};

const ChangeEmailPage = () => {
  // State for the currently selected email type
  const [selectedType, setSelectedType] = useState('admin');
  // State for the email content being edited
  const [emailContent, setEmailContent] = useState('');
  // Message to display after saving
  const [saveMessage, setSaveMessage] = useState('');

  // Set your API base URL (adjust if needed)
  const API_BASE_URL = 'https://casaahaanahotels.com';

  // Fetch the current template from the server when the selected type changes
  useEffect(() => {
    fetch(`${API_BASE_URL}/emailTemplates/${selectedType}`)
      .then(response => response.json())
      .then(data => {
        if (data.template) {
          setEmailContent(data.template);
        } else {
          setEmailContent('');
        }
      })
      .catch(error => {
        console.error('Error fetching template:', error);
        setEmailContent('');
      });
  }, [selectedType, API_BASE_URL]);

  // Handler to update the template on the server
  const handleSave = () => {  
    fetch(`${API_BASE_URL}/emailTemplates/${selectedType}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ template: emailContent })
    })
      .then(response => response.json())
      .then(data => {
        if (data.message) {
          setSaveMessage(data.message);
          setTimeout(() => setSaveMessage(''), 3000);
        }
      })
      .catch(error => {
        console.error('Error saving template:', error);
      });
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Change Email Template</h1>

      <div className={styles.formGroup}>
        <label htmlFor="emailType" className={styles.label}>
          Select Email Type:
        </label>
        <select
          id="emailType"
          value={selectedType}
          onChange={(e) => setSelectedType(e.target.value)}
          className={styles.select}
        >
          {Object.entries(EMAIL_TYPES).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </select>
      </div>

      <div className={styles.editorContainer}>
      <ReactQuill
  theme="snow"
  value={emailContent}
  onChange={setEmailContent}
  className={styles.editor}
  modules={{
    toolbar: [
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
      [{ 'script': 'sub' }, { 'script': 'super' }],     // superscript/subscript
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],         // outdent/indent
      ['blockquote', 'code-block'],
      ['link', 'image', 'video'],                       // media
      ['clean']                                         // remove formatting
    ]
  }}
/>

      </div>

      <button onClick={handleSave} className={styles.saveButton}>
        Save
      </button>

      {saveMessage && <p className={styles.saveMessage}>{saveMessage}</p>}
    </div>
  );
};

export default ChangeEmailPage;
